'use strict'

function getValueById(id){
    return $(`#${id}`).val();
}

function setTextById(id,value){
    console.log("value: " + value);
     if(value != null || value != "" || value != undefined){
        return $(`#${id}`).text(value);
     }
     return $(`#${id}`).text("-");
}

function beforeLoadingButton(el, val=null) {
    if(val ==null) {
        el.html('<div class="d-flex justify-content-center align-items-center"><span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> Loading...</div>');
    } else {
        el.html(`<div class="d-flex justify-content-center align-items-center"><span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> ${val}</div>`);
    }
    el.addClass('disabled');
    el.prop('disabled', true);
}

function afterLoadingButton(el, val=null){
    if(val ==null) {
        el.html('Save');
    } else {
        el.html(val);
    }
    el.removeClass('disabled');
    el.prop('disabled', false);
}

function showMessage(status,title,message){
    Swal.fire(
        title,
        message,
        status
    );
}

// HTTP REQUEST
async function postData(url = '', data = {}) {
    return await axios.post(url, data)
}

async function deleteData(url = '', data = {}) {
    return await axios.delete(url, data)
}

async function updateData(url = '', id, data = {}) {
    return await axios.post(url, id, data)
}

async function putData(url = '', data = {}) {
    return await axios.put(url, data)
}

async function getData(url, id) {
    return await axios.get(url, id)
}

async function getResult(url,params) {
    return await axios.get(url,{params: params})
}

async function getRegion(url = '', data = {}) {
    return await axios.get(url, {params: data})
}

/* Date Time Fuction */

function convertDateTimeId(input){
    let date = new Date(input);
    if(input != new Date())
        date = new Date(input);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const day = String(date.getDate()).padStart(2, '0'); 
    const result = year + "-" + month + "-" + day;
    return result;
}

function formatErrorMessage(jqXHR, exception) {
    if (jqXHR.status === 0) {
        return ('Not connected.\nPlease verify your network connection.');
    } else if (jqXHR.status == 404) {
        return ('The requested page not found.');
    }  else if (jqXHR.status == 401) {
        return ('Sorry!! You session has expired. Please login to continue access.');
    } else if (jqXHR.status == 500) {
        return ('Terjadi kesalahan, silahkan coba lagi.');
    } else if (exception === 'parsererror') {
        return ('Requested JSON parse failed.');
    } else if (exception === 'timeout') {
        return ('Time out error.');
    } else if (exception === 'abort') {
        return ('Ajax request aborted.');
    } else {
        return ('Unknown error occured. Please try again.');
    }
}

function getBatteryCapacity12V(voltage) {
    // Define the voltage-to-capacity mapping as an array of objects
    const voltageCapacityMap = [
        { voltage: 13.00, capacity: 100 },
        { voltage: 12.80, capacity: 99 },
        { voltage: 12.75, capacity: 90 },
        { voltage: 12.50, capacity: 80 },
        { voltage: 12.30, capacity: 70 },
        { voltage: 12.15, capacity: 60 },
        { voltage: 12.05, capacity: 50 },
        { voltage: 11.95, capacity: 40 },
        { voltage: 11.81, capacity: 30 },
        { voltage: 11.66, capacity: 20 },
        { voltage: 11.51, capacity: 10 },
        { voltage: 10.50, capacity: 0 }
    ];

    // Iterate through the mapping to find the closest range
    for (let i = 0; i < voltageCapacityMap.length - 1; i++) {
        const { voltage: v1, capacity: c1 } = voltageCapacityMap[i];
        const { voltage: v2, capacity: c2 } = voltageCapacityMap[i + 1];

        if (voltage >= v2 && voltage <= v1) {
            // Linear interpolation between two points
            const fraction = (voltage - v2) / (v1 - v2);
            return Math.round(c2 + fraction * (c1 - c2));
        }
    }

    // If voltage is outside the range, return 0 or 100
    return voltage > 26.00 ? 100 : null;
}

function getBatteryCapacity(voltage) {
    if (voltage == null) {
        return null;
    }

    let percent;

    // Auto-detect sistem 12V atau 24V
    if (voltage < 18.0) {
        // Sistem 12V
        const low12 = 10.5;
        const high12 = 12.8;

        percent = ((voltage - low12) / (high12 - low12)) * 100;
    } else {
        // Sistem 24V
        const low24 = 23.0;
        const high24 = 25.7;

        percent = ((voltage - low24) / (high24 - low24)) * 100;
    }

    // Clamping 0-100%
    if (percent > 100) {
        percent = 100;
    } else if (percent < 0) {
        percent = 0;
    }

    return Math.floor(percent); // sama seperti int32(percent) di Go
}

/**
 * Format number with Indonesian locale (thousands: . , decimal: ,)
 * @param {number|string} val Value to format
 * @param {number} decimals Number of decimal places
 * @returns {string} Formatted string
 */
function formatIndonesianNumber(val, decimals = 2) {
    if (val === null || val === undefined || isNaN(val)) return "-";

    return Number(val).toLocaleString('id-ID', {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimals
    });
}
